module.exports = "<ul class=\"tools__list\">\n    <li class=\"tools__item tools__item_delete\"\n        (click)=\"onDelete()\">\n        Удалить\n    </li>\n    <li class=\"tools__item tools__item_not-spam\"\n        (click)=\"onNotSpam()\">Не спам</li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/tools/spam-letter-tools/spam-letter-tools.component.html
// module id = 628
// module chunks = 1